import stickyTHeadStyle from "constants/stickyTHeadStyle";
import { editBulkLocations } from "helpers/fakebackend_helper";
import { FILES_URL } from "helpers/url_helper";
import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    Input,
} from "reactstrap";

const BulkLocationEdit = ({ locations, accountManagers, loadLocations }) => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const [modalVisible, setModalVisible] = useState(false);
    const [editedLocations, setEditedLocations] = useState([]);
    const [originalLocations, setOriginalLocations] = useState([]);
    const [stickyColumns, setStickyColumns] = useState(["Location Name"]);

    const columns = [
        { key: "Logo", label: "Logo", minWidth: 200 },
        { key: "Location Name", label: "Location Name", minWidth: 180 },
        { key: "Spaces", label: "Spaces", minWidth: 90 },
        { key: "Monthly Parking Capacity", label: "Monthly Parking Capacity", minWidth: 100 },
        { key: "Property Type", label: "Property Type", minWidth: 130 },
        { key: "Account Manager", label: "Account Manager", minWidth: 150 },
        { key: "Invoicing Type", label: "Invoicing Type", minWidth: 130 },
        { key: "Daily Lease Amount", label: "Daily Lease Amount", minWidth: 100 },
        { key: "Operating Structure", label: "Operating Structure", minWidth: 110 },
        { key: "Cash Accepted", label: "Cash Accepted", minWidth: 100 },
        { key: "Monthly Parking", label: "Monthly Parking", minWidth: 100 },
        { key: "Labor Hours Cap", label: "Labor Hours Cap", minWidth: 100 },
        { key: "Is CurbAds Location?", label: "Is CurbAds Location?", minWidth: 130 },
        { key: "Tax Status", label: "Tax Status", minWidth: 120 },
        { key: "Manager Rate", label: "Manager Rate" },
        { key: "Attendant Rate", label: "Attendant Rate" },
        { key: "Management Fee", label: "Management Fee" },
        { key: "Parking Lot Fee", label: "Parking Lot Fee", minWidth: 120 },
        { key: "Permit/Meter Fee", label: "Permit/Meter Fee" },
        { key: "Tech Fee", label: "Tech Fee", minWidth: 100 },
        { key: "Ops Supplies Fee", label: "Ops Supplies Fee", minWidth: 100 },
        { key: "Partner Remittance Fee", label: "Partner Remittance Fee" },
        { key: "Parking Lot Cost", label: "Parking Lot Cost", minWidth: 120 },
        { key: "Insurance Fee", label: "Insurance Fee", minWidth: 100 },
    ];

    const toggleSticky = (key) => {
        setStickyColumns((prev) =>
            prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
        );
    };

    const getStickyStyle = (index, key, minWidth) => {
        if (!stickyColumns.includes(key)) return { minWidth };
        const leftOffset = columns
            .slice(0, index)
            .filter((c) => stickyColumns.includes(c.key))
            .reduce((sum, c) => sum + (c.minWidth || 120), 0);
        return {
            minWidth,
            position: "sticky",
            left: leftOffset,
            background: "#fff",
            zIndex: 2,
        };
    };

    useEffect(() => {
        if (Array.isArray(locations)) {
            setEditedLocations(locations.map(loc => ({ ...loc })));
            setOriginalLocations(locations.map(loc => ({ ...loc }))); // keep copy for diff
        }
    }, [locations]);

    const handleChange = (id, field, value) => {
        setEditedLocations((prev) =>
            prev.map((loc) =>
                loc.id === id ? { ...loc, [field]: value } : loc
            )
        );
    };

    const handleFileChange = (id, file) => {
        setEditedLocations((prev) =>
            prev.map((loc) =>
                loc.id === id ? { ...loc, logo_file: file } : loc
            )
        );
    };

    const handleBulkSave = async () => {
        const changes = editedLocations.map((edited) => {
            const original = originalLocations.find(o => o.id === edited.id);
            if (!original) return null;

            const diff = {};
            Object.keys(edited).forEach((key) => {
                if (edited[key] !== original[key]) {
                    diff[key] = edited[key];
                }
            });

            if (Object.keys(diff).length > 0) {
                return { id: edited.id, ...diff };
            }
            return null;
        }).filter(Boolean);

        await editBulkLocations(user.token, changes);
        loadLocations(true)
        setModalVisible(false);
    };

    return (
        <>
            <Button className="button-gradient-bg" onClick={() => setModalVisible(true)}>
                Bulk Edit Locations
            </Button>
            <Modal
                isOpen={modalVisible}
                toggle={() => setModalVisible(false)}
                size="xl"
                style={{ maxWidth: "98%" }}
            >
                <ModalHeader toggle={() => setModalVisible(false)}>
                    Bulk Location Edit
                </ModalHeader>
                <ModalBody style={{ overflowX: "auto" }}>
                    <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
                        <table className="table table-bordered table-hover mb-0">
                            <thead style={stickyTHeadStyle}>
                                <tr>
                                    {columns.map((col, i) => (
                                        <th key={col.key} style={{ ...getStickyStyle(i, col.key, col.minWidth) }}>
                                            <div className="d-flex flex-column align-items-center">
                                                <Input
                                                    type="checkbox"
                                                    checked={stickyColumns.includes(col.key)}
                                                    onChange={() => toggleSticky(col.key)}
                                                />
                                                <span>{col.label}</span>
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {editedLocations
                                    .slice()
                                    .sort((a, b) => a.location_name.localeCompare(b.location_name))
                                    .map((loc) => (
                                        <tr key={loc.id}>
                                            {columns.map((col, index) => {
                                                const style = getStickyStyle(index, col.key, col.minWidth);

                                                switch (col.key) {
                                                    case "Logo":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <img
                                                                    src={
                                                                        loc.logo_files?.[0]
                                                                            ? `${FILES_URL}${loc.logo_files[0].file_name}`
                                                                            : "https://placehold.co/150x150"
                                                                    }
                                                                    alt="Client Logo"
                                                                    style={{ maxHeight: "50px", maxWidth: "150px" }}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = "https://placehold.co/150x150";
                                                                    }}
                                                                />
                                                                <Input
                                                                    type="file"
                                                                    onChange={(e) =>
                                                                        handleFileChange(loc.id, e.target.files[0])
                                                                    }
                                                                />
                                                            </td>
                                                        );

                                                    case "Location Name":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="text"
                                                                    value={loc.location_name || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(loc.id, "location_name", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                        );

                                                    case "Spaces":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="number"
                                                                    value={loc.location_spaces || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(loc.id, "location_spaces", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                        );

                                                    case "Monthly Parking Capacity":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="number"
                                                                    value={loc.monthly_parking_capacity || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            loc.id,
                                                                            "monthly_parking_capacity",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                />
                                                            </td>
                                                        );

                                                    case "Property Type":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="select"
                                                                    value={loc.location_type || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(loc.id, "location_type", e.target.value)
                                                                    }
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="Hotel">Hotel</option>
                                                                    <option value="Office Building">Office Building</option>
                                                                    <option value="Apartment / Condo">Apartment / Condo</option>
                                                                    <option value="Restaurant">Restaurant</option>
                                                                    <option value="Retail Center">Retail Center</option>
                                                                    <option value="Health Club">Health Club</option>
                                                                    <option value="Airport">Airport</option>
                                                                    <option value="Parking Lot">Parking Lot</option>
                                                                </Input>
                                                            </td>
                                                        );

                                                    case "Account Manager":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="select"
                                                                    value={loc.account_manager_id || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            loc.id,
                                                                            "account_manager_id",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    {accountManagers.map((am) => (
                                                                        <option key={am.id} value={am.id}>
                                                                            {am.full_name}
                                                                        </option>
                                                                    ))}
                                                                </Input>
                                                            </td>
                                                        );

                                                    case "Invoicing Type":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="select"
                                                                    value={loc.invoicing_type || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(loc.id, "invoicing_type", e.target.value)
                                                                    }
                                                                >
                                                                    <option value="Variable">Variable</option>
                                                                    <option value="Flat">Flat</option>
                                                                    <option value="No Invoice">No Invoice</option>
                                                                </Input>
                                                            </td>
                                                        );

                                                    case "Daily Lease Amount":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="number"
                                                                    value={loc.lease_amount || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(loc.id, "lease_amount", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                        );

                                                    case "Operating Structure":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="select"
                                                                    value={loc.operating_structure || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            loc.id,
                                                                            "operating_structure",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option value="Lease">Lease</option>
                                                                    <option value="Non Lease">Non Lease</option>
                                                                </Input>
                                                            </td>
                                                        );

                                                    case "Cash Accepted":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="select"
                                                                    value={loc.is_cash_accepted}
                                                                    onChange={(e) =>
                                                                        handleChange(loc.id, "is_cash_accepted", e.target.value)
                                                                    }
                                                                >
                                                                    <option value={1}>Yes</option>
                                                                    <option value={0}>No</option>
                                                                </Input>
                                                            </td>
                                                        );

                                                    case "Monthly Parking":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="select"
                                                                    value={loc.is_monthly_parking_active}
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            loc.id,
                                                                            "is_monthly_parking_active",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option value={1}>Yes</option>
                                                                    <option value={0}>No</option>
                                                                </Input>
                                                            </td>
                                                        );

                                                    case "Labor Hours Cap":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="number"
                                                                    value={loc.labor_hours_cap || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(loc.id, "labor_hours_cap", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                        );

                                                    case "Is CurbAds Location?":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="select"
                                                                    value={loc.is_curbads_location}
                                                                    onChange={(e) =>
                                                                        handleChange(
                                                                            loc.id,
                                                                            "is_curbads_location",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option value={1}>Yes</option>
                                                                    <option value={0}>No</option>
                                                                </Input>
                                                            </td>
                                                        );

                                                    case "Tax Status":
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="select"
                                                                    value={loc.tax_status || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(loc.id, "tax_status", e.target.value)
                                                                    }
                                                                >
                                                                    <option value="">NONE</option>
                                                                    <option value="POT Tax">POT Tax</option>
                                                                </Input>
                                                            </td>
                                                        );

                                                    default:
                                                        // All remaining numeric fee fields
                                                        const fieldMap = {
                                                            "Manager Rate": "manager_labor_rate",
                                                            "Attendant Rate": "attendant_labor_rate",
                                                            "Management Fee": "management_fee",
                                                            "Parking Lot Fee": "parking_lot_fee",
                                                            "Permit/Meter Fee": "permit_meter_fee",
                                                            "Tech Fee": "tech_fee",
                                                            "Ops Supplies Fee": "ops_supplies_fee",
                                                            "Partner Remittance Fee": "partner_remittance_fee",
                                                            "Parking Lot Cost": "parking_lot_cost",
                                                            "Insurance Fee": "insurance_fee",
                                                        };

                                                        const field = fieldMap[col.key];
                                                        return (
                                                            <td key={col.key} style={style}>
                                                                <Input
                                                                    type="number"
                                                                    value={loc[field] || ""}
                                                                    onChange={(e) =>
                                                                        handleChange(loc.id, field, e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                        );
                                                }
                                            })}
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setModalVisible(false)}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={handleBulkSave}>
                        Bulk Save
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default BulkLocationEdit;